module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=PN - Pitcairn Islands.1d37b368.svg";